import Vue from 'vue'
import App from './App.vue'
import router from './router'
import { store } from './store/store';

import VueApexCharts from 'vue-apexcharts'
import VueGoodTablePlugin from 'vue-good-table';
import Multiselect from 'vue-multiselect'
// import the styles
import 'vue-good-table/dist/vue-good-table.css'
import "vue-multiselect/dist/vue-multiselect.min.css";

Vue.use(VueGoodTablePlugin);

Vue.use(VueApexCharts)
Vue.component('apexchart', VueApexCharts)
Vue.component('multiselect', Multiselect)
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
